import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../services/common/http/common.http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IDiarioObraForm } from './diario-obra-layout.model';
import { FileRead } from '../../../components/drag-drop/drag-drop.model';
import { IDocumentoModalData } from '../../recursos-humanos/modal-documento-layout/modal-documento-layout.model';
import { AppExportBase64 } from '../../../services/exportBase64/exportBase64.service';
import Swal from 'sweetalert2';
import { formatDateForInput2 } from '../../../utils/utility-functions';
import { format } from 'date-fns';

@Component({
  selector: 'app-diario-obra-layout',
  templateUrl: './diario-obra-layout.component.html',
  styleUrls: ['./diario-obra-layout.component.scss'],
})
export class DiarioObraLayoutComponent implements OnInit {
  isEditing: boolean = false;
  documentoModalData: IDocumentoModalData = {};
  visibleModalDocumento: boolean = false;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private exportBase64Service: AppExportBase64
  ) {}

  ngOnInit() {
    this.activateRoute();
  }

  form: IDiarioObraForm = {
    IdDiarioObra: 0,
    FuncionarioResponsavelId: 0,
    ObraId: 0,
    TxEndereco: '',
    DtInicio: '',
    TxPrazoDias: '',
    DtDiario: String(format(new Date(), 'yyyy-MM-dd')),
    TxAnotacao: '',
    ImagensObra: [],
  };

  obrasOptions: any[] = [];
  responsavelOptions: any[] = [];

  postForm(): void {
    !this.isEditing ? this.createDiario() : this.editDiario();
  }

  createDiario(): void {
    this.loader = true;
    this.httpService.usePostFilter('CreateDiarioObra', this.form).subscribe({
      next: (res: any) => {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Diário de obra cadastrado com sucesso.',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
        }).then(() => {
          this.router.navigate(['planejamento']);
        });
      },
      error: (err: any) => {
        Swal.fire({
          title: 'Erro!',
          text: 'Erro ao cadastrar o diário de obra.',
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'red',
        });
      },
      complete: () => {
        this.loader = false;
      },
    });
  }

  editDiario(): void {
    this.loader = true;
    const id = this.form.IdDiarioObra;
    this.httpService
      .usePut('UpdateDiarioObra', this.form, { idDiarioObra: id })
      .add(() => {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Diário de obra atualizado com sucesso.',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
        }).then(() => {
          this.router.navigate(['planejamento']);
        });
        this.loader = false;
      });
  }

  getObras(): void {
    this.httpService.useGet('FrenteTrabalho').subscribe({
      next: (res: any) => {
        this.obrasOptions = res.FrenteTrabalhos.map((x: any) => {
          return {
            name: x.TxNome,
            value: x.IdFrenteTrabalho,
          };
        });
      },
      error: (err: any) => {},
      complete: () => {},
    });
  }

  getResponsaveis() {
    this.httpService
      .useGet('FuncionarioByFilter', { NuStatusFuncionario: 2 })
      .subscribe({
        next: (res: any) => {
          this.responsavelOptions = res.DataSet.map((x: any) => ({
            value: x.FuncionarioId,
            name: x.TxNome,
          }));
        },
        error: (err: any) => {},
        complete: () => {},
      });
  }

  updateObra(value: number): void {
    if (!value) return;
    this.loader = true;
    this.form.ObraId = value;
    this.httpService
      .useGet('FrenteTrabalhoByFilter', { IdFrenteTrabalho: value })
      .subscribe({
        next: (res: any) => {
          const data = res.DataSet[0];

          let endereco = '';
          if (data.Endereco != null && data.Endereco != '')
            endereco += data.Endereco;

          if (data.NuResidencia != null && data.NuResidencia != '')
            endereco += ` - ${data.NuResidencia}, `;

          if (data.Cidade != null && data.Cidade != '')
            endereco += `${data.Cidade},`;

          if (data.Cep !== null && data.Cep != '')
            endereco += this.formatCep(data.Cep);

          this.form.TxEndereco = endereco == '' ? 'Não informado' : endereco;
          this.form.DtInicio = String(data.DtInicio).split('T')[0];
          this.form.TxPrazoDias = data.QtPrazo;
        },
        error: (err: any) => {},
        complete: () => {
          this.loader = false;
        },
      });
  }

  onFileDropped(file: FileRead): void {
    const formattedBase64 = file.base64.replace(
      /^data:image\/jpeg;base64,/,
      ''
    );

    const containImage = this.form.ImagensObra?.find(
      (image) => image.NmImagemObra === file.name
    );
    if (containImage) return;

    this.form.ImagensObra?.push({
      TxImagemObra: formattedBase64,
      NmImagemObra: file.name,
    });
  }

  visualizarDocumento(base64?: string, nomeDocumento?: string): void {
    this.documentoModalData = {
      base64,
      nomeDocumento,
    };
    this.visibleModalDocumento = !this.visibleModalDocumento;
  }

  downloadArquivo(base64: any, name: string): void {
    const arquivo = base64;
    this.exportBase64Service.downloadJPG(arquivo, name);
  }
  formatCep(cep: string): string {
    if (cep) {
      return cep.replace(/^(\d{5})(\d{3})/, '$1-$2');
    }
    return '';
  }

  validarForm(): boolean {
    if (
      this.form.ObraId &&
      this.form.FuncionarioResponsavelId &&
      this.form.DtDiario &&
      this.form.TxAnotacao &&
      this.form.ImagensObra?.length
    ) {
      return false;
    }
    return true;
  }

  activateRoute(): void {
    this.loader = true;
    this.getObras();
    this.getResponsaveis();
    this.activatedRoute.queryParams.subscribe((params) => {
      const id = +params['id'];
      if (!id) {
        this.loader = false;
        return;
      }
      this.isEditing = true;
      this.httpService
        .useGet('DiarioObraById', { idDiarioObra: id })
        .subscribe({
          next: (res: any) => {
            const data = res.DataSet;
            this.form.IdDiarioObra = data.IdDiarioObra;
            this.form.ObraId = data.FrenteTrabalhoId;
            this.form.FuncionarioResponsavelId = data.FuncionarioId;
            this.form.TxAnotacao = data.TxAnotacao;
            this.form.DtDiario = String(data.DtDiario).split('T')[0];
            this.form.ImagensObra = data.ImagemDiarioObra.map((item: any) => {
              return {
                TxImagemObra: item.TxImagemDiarioObra,
                NmImagemObra: item.NmImagemDiarioObra,
              };
            });
            this.updateObra(data.FrenteTrabalhoId);
          },
          error: (err: any) => {
            this.loader = false;
          },
          complete: () => {
            this.loader = false;
          },
        });
    });
  }
}
